import React from 'react';

function AtmMachine(props) {
	return (
		<svg height="30" width="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000" strokeLinecap="butt" strokeLinejoin="miter">
		<path d="M23.5 19.74v-14.1a2.82 2.82 0 0 0-2.82-2.82h-11.28a2.82 2.82 0 0 0-2.82 2.82v14.1" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M19.74 6.58h-9.4v5.64h9.4v-5.64z" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M16.92 15.98h2.82" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
		<path d="M26.32 23.5h-22.56v3.76h22.56v-3.76z" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2"/>
	</g>
</svg>
	);
};

export default AtmMachine;